<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <validation-observer ref="proforma">
          <b-form @submit.prevent>
            <b-card no-body class="invoice-preview-card">
              <!-- Header -->
              <b-card-body class="invoice-padding pb-0">
                <!-- Header: Left Content -->
                <div class="row align-items-center mb-2">
                  <div class="col-3">
                    <Logo />
                  </div>
                  <div class="col-9">
                    <div class="">
                      <CompanyName />
                    </div>
                    <div class="">
                      <Address />
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end flex-md-row flex-column invoice-spacing mt-0">
                  <!-- Header: Right Content -->
                  <div class="invoice-number-date mt-md-0 mt-2">
                    <div class="d-flex align-items-center justify-content-md-end mb-1">
                      <h4 class="invoice-title">Proforma Invoice</h4>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="title"> Date: </span>
                      <div>
                        <flat-pickr v-model="issuedDate" :config="config.wrap" class="form-control invoice-edit-input" />
                        <small v-if="issueDateError" class="text-danger">{{ issueDateError }}</small>
                      </div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <validation-provider rules="required" v-slot="{ errors }" name="Due Date" vid="Due Date">
                        <div class="d-flex">
                          <span class="title">Due Date:*</span>
                          <div>
                            <flat-pickr v-model="dueDate" :config="configDue.wrap"
                              class="form-control invoice-edit-input" />
                              <small v-if="dueDateError" class="text-danger">{{ dueDateError }}</small>
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </div>
                        </div>
                      </validation-provider>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="title"> Select Currency:* </span>

                      <b-form-select id="currencySelect" v-model="selectedCurrency" size="lg" :options="currencyOptions"
                        style="width: 100px" />
                    </div>
                    <div class="d-flex align-items-center mb-1" v-if="selectedCurrency !== 'MUR'">
                      <span class="title"> Enter rate:* </span>
                      <validation-provider rules="required|min_value:0.01" v-slot="{ errors }" name="Rate" vid="Rate">
                        <b-form-input id="exchangeRate" v-model="exchangeRate" placeholder="Enter rate" type="number"
                          size="lg" style="width: 150px" @onkeydown="numericValidation(event)"
                          @blur="updateInvoiceDataOnRateChange" />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing" />

              <b-card-body class="invoice-padding pt-0">
                <b-row class="invoice-spacing">
                  <!-- Col: Invoice To -->
                  <b-col cols="6" xl="6" class="mb-lg-1">
                    <h6 class="mb-2">Send Proforma To:</h6>
  
                    <!-- Selected Client -->
  
                    <div v-if="whenSelected !== null" class="mt-1">
                      <b-card-text class="mb-25">
                        {{ whenSelected.otherName }}
                      </b-card-text>
  
                      <b-card-text class="mb-25">
                        {{ whenSelected.addressLine1 }}
                        {{ whenSelected.addressLine2 }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ whenSelected.city }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ whenSelected.tel }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ whenSelected.email }}
                      </b-card-text>
                    </div>
                    
                  </b-col>
                  <!-- <b-col cols="6" xl="6" class="mb-lg-1">
                    <div>
                      <validation-provider rules="required" v-slot="{ errors }" name="Order Type" vid="Order Type">
                        <b-form-group label="Order Type:*" label-for="orderType">
                          <b-form-select id="orderType" v-model="orderType" :options="optionsOrderTypeDLL"
                            placeholder="Please select an option" />
                        </b-form-group>
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </div>
                  </b-col> -->
                </b-row>
              </b-card-body>

              <!-- Items Section -->
              <b-card-body class="invoice-padding">
                <div ref="form" class="repeater-form" :style="{ height: trHeight }">
                  <b-row v-for="(item, index) in invoiceData.items" :key="`items_${index}`" ref="row" class="pb-2">
                    <!-- Item Form -->
                    <!-- ? This will be in loop => So consider below markup for single item -->
                    <b-col cols="12">
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <!-- Form Input Fields OR content inside bordered area  -->
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <div class="d-flex border rounded">
                        <div>
                          <b-row class="flex-grow-1 p-2 pt-2">
                            <!-- Single Item Form Headers -->
                            <b-col cols="12" :lg="vat ? 6 : 8">
                                                            <label class="static-label">Items*</label>
                              <div v-if="newProd" class="d-flex justify-content-center">
                                <b-spinner variant="primary"></b-spinner>
                              </div>
                              <div v-else class="d-flex">
                                <div class="flex-grow-1 mr-1">
                                  <validation-provider rules="required" v-slot="{ errors }" name="Item"
                                    :vid="`Item_${index}`">
                                    <v-select v-model="item.id" :options="optionsProduct" label="itemTitle" :dir="$store.state.appConfig.isRTL
                                      ? 'rtl'
                                      : 'ltr'
                                      " :clearable="false" :searchable="true" :class="[
                                        { 'is-invalid': errors.length },
                                        'item-selector-title',
                                      ]" placeholder="Select Item" @input="(val) => {
                                        updateItemForm(
                                          index,
                                          val,
                                          exchangeRate,
                                          selectedCurrency
                                        );
                                        //updateInvoiceDataOnRateChange();
                                      }
                                        ">
                                      <template #option="{ itemTitle, categoryName, subCategoryName }">
                                        <div style="display: flex; flex-direction: column;">
                                          <span>{{ itemTitle }}</span>
                                          <span>{{ categoryName || '-' }} : {{ subCategoryName || '-' }}</span>
                                        </div>
                                      </template>
                                    </v-select>

                                    <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </div>
                                <div>
                                  <!-- Button Add Item -->
                                  <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-modal.modal-addProduct
                                    variant="primary" size="md">
                                    +
                                  </b-button>
                                </div>
                                <!-- modal Add Item-->
                                <!-- <b-modal
                                  id="modal-addProduct"
                                  cancel-variant="outline-secondary"
                                  ok-title="Save"
                                  cancel-title="Close"
                                  centered
                                  title="Add Product"
                                  @ok="addProduct"
                                >
                                  <b-form
                                    @submit.stop.prevent="handleProdSubmit"
                                  >
                                    <b-form-group>
                                      <label for="name">Name:</label>
                                      <b-form-input
                                        :id="`name_${index}`"
                                        type="text"
                                        placeholder="Name"
                                        v-model="prodName"
                                      />
                                    </b-form-group>
                                    <b-form-group>
                                      <label for="qty">Quantity:</label>
                                      <b-form-input
                                        id="qty"
                                        type="number"
                                        placeholder="Quantity"
                                        v-model="prodQty"
                                      />
                                    </b-form-group>
                                  </b-form>
                                </b-modal> -->
                              </div>
                            </b-col>
                            <!-- <b-col cols="12" lg="2">
                              <span class="d-inline d-lg-none">Cost Price</span>
                              <validation-provider
                                rules="required|min_value:0"
                                v-slot="{ errors }"
                                name="Cost Price"
                                :vid="`CostPrice_${index}`"
                              >
                                <b-form-input
                                  v-model="item.purchase"
                                  type="number"
                                  class="mb-2"
                                  @input="updateItemCost(index)"
                                />
                                <small
                                  v-if="errors.length"
                                  class="text-danger"
                                  >{{ errors[0] }}</small
                                >
                              </validation-provider>
                            </b-col> -->
                            <b-col cols="12" lg="2">
                              <label class="static-label">Unit Price ({{ selectedCurrencySign }})*</label>
                              <b-form-input v-model="item.cost" type="number" class="mb-2" @keypress="allowOnlyNumbers($event)"
                              @input="sanitizeInput('cost')"/>
                            </b-col>

                            <b-col cols="12" lg="2"  v-if="vat">
                              <label class="static-label"> VAT (%)</label>
                              <b-form-input v-model="item.tax" type="number" class="mb-2" @keypress="allowOnlyNumbers($event)"
                              @input="sanitizeInput('tax')"/>
                            </b-col>
                            <b-col cols="12" lg="2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="flex-grow-1">
                              <label class="static-label">Qty*</label>
                              <validation-provider rules="required|min_value:1" v-slot="{ errors }" name="Quantity"
                                :vid="`Quantity${index}`">
                                <b-form-input v-model="item.qty" type="number" :class="[
                                  { 'is-invalid': errors.length },
                                  'mb-2',
                                ]" @keypress="allowOnlyNumbers($event)"
                                @input="sanitizeInput('qty')"/>
                                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </div>
                          </div>
                          <div class="mb-1">
                            <b-button
                          variant="danger"
                          size="sm"
                          @click="removeItem(index)"
                        >
                          Remove
                        </b-button>
                          </div>
                            </b-col>

                            <b-col cols="12" lg="12">
                              <span class="d-inline d-lg-none">Description</span>
                              <b-form-textarea v-model="item.description" class="mb-2 mb-lg-0" />
                            </b-col>
                            <!-- Col: Discount Type -->
                            <!-- <b-col
                              cols="12"
                              md="4"
                              class="mt-md-0 mt-3 d-flex align-items-center"
                            >
                              <span
                                for="invoice-discount-type"
                                class="text-nowrap mr-50"
                                >Discount Type:</span
                              >
                              <b-form-select
                                id="invoice-discount-type"
                                v-model="item.discountType"
                                :options="discountTypeOptions"
                              />
                            </b-col> -->

                            <!-- Col: Discount Value -->
                            <!-- <b-col
                              cols="12"
                              md="4"
                              class="mt-md-0 mt-3 d-flex align-items-center"
                            >
                              <span
                                for="invoice-discount-value"
                                class="text-nowrap mr-50"
                                >Discount Value:</span
                              >
                              <validation-provider
                                rules="min_value:0"
                                v-slot="{ errors }"
                                name="Discount"
                                :vid="`Discount_${index}`"
                              >
                                <b-form-input
                                  id="invoice-discount-value"
                                  v-model="item.discount"
                                  type="number"
                                  @input="validateDiscount(index)"
                                  @blur="ensureNotNull(index)"
                                />
                                <small
                                  v-if="errors.length"
                                  class="text-danger"
                                  >{{ errors[0] }}</small
                                >
                              </validation-provider>
                            </b-col> -->
                          </b-row>
                          <hr />
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary"
                  @click="addNewItemInItemForm">
                  Add Item
                </b-button>
              </b-card-body>

              <!-- Invoice Description: Total -->
              <b-card-body class="invoice-padding pb-0">
                <b-row>
                  <!-- Col: Sales Persion -->
                  <b-col cols="12" md="4" class="mt-md-0 mt-3 d-flex align-items-center" order="2" order-md="1">
                    <b-row>
                      <b-col cols="12">
                        <span for="invoice-data-sales-person" class="text-nowrap mr-50">Sales Person:*</span>
                        <validation-provider rules="required" v-slot="{ errors }" name="Sales Person"
                          vid="Sales Person">
                          <b-form-select v-model="salesPersonId" :options="optionsSalesPerson" />
                          <small v-if="errors.length" class="text-danger">{{
                            errors[0]
                          }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12">
                        <div class="box-1">
                          <span for="invoice-data-warehouse" class="text-nowrap mr-50">Choose Warehouse:*</span>
                          <validation-provider rules="required" v-slot="{ errors }" name="Warehouse" vid="Warehouse">
                            <b-form-select v-model="warehouseId" :options="optionsWarehouse" />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- Col: Total -->

                  <b-col cols="12" md="8" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                    <div class="invoice-total-wrapper">
                      <b-row>
                        <b-col> Discount Rate: </b-col>
                        <b-col>
                          <validation-provider :rules="`min_value:0|max_value:${maxDiscountValue}`" v-slot="{ errors }"
                            name="Discount" :vid="`Discount_${index}`">
                            <b-form-input id="invoice-discount-value" v-model="MainDiscount" type="number"
                              :placeholder="discountPlaceholder" @blur="ensureMainDiscountNotNull" />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <div class="invoice-total-item mt-1">
                        <p class="invoice-total-title">Discount:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }}
                          {{ this.discountTotal.toFixed(2) }}
                        </p>
                      </div>

                      <div class="invoice-total-item">
                        <p class="invoice-total-title">Subtotal:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }} {{ subTotal.toFixed(2) }}
                        </p>
                      </div>

                      <div class="invoice-total-item" v-if="vat">
                        <p class="invoice-total-title">VAT:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }} {{ VATtotal.toFixed(2) }}
                        </p>
                      </div>

                      <hr class="my-50" />
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">Total:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }} {{ finalTotal }}
                        </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing" />

              <!-- Note -->
              <b-card-body class="invoice-padding pt-0">
                <span class="font-weight-bold">Note: </span>
                <b-form-textarea v-model="note" />
              </b-card-body>
            </b-card>
          </b-form>
        </validation-observer>

        <validation-observer ref="addProduct">
          <!-- modal Add Item-->
          <b-modal id="modal-addProduct" :hide-footer="true" ref="addProductModal" centered title="Add Product">
            <b-form @submit.prevent="handleProdSubmit">
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label for="name">Name:</label>
                    <validation-provider rules="required" #default="{ errors }" name="name">
                      <b-form-input id="name" type="text" placeholder="Name" v-model="prodName" required />
                      <small v-if="errors.length" class="text-danger text-end">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label for="qty">Quantity:</label>
                    <validation-provider rules="required" #default="{ errors }" name="quantity">
                      <b-form-input id="qty" type="number" placeholder="Quantity" v-model="prodQty" required @keypress="allowOnlyNumbersProd($event)" />
                      <small v-if="errors.length" class="text-danger text-end">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox v-model="prodInHouse" id="checkbox">
                      Product Manufactured InHouse
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="justify-content-end">
                <!--    <b-col cols="3">
         Button Add Item 
       <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-secondary" @click="resetProductModal">
          Close
        </b-button> 
      </b-col> -->
                <b-col cols="auto">
                  <!-- Button Add Item -->
                  <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="addProduct">
                    Save
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
        </validation-observer>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
        <!-- Action Buttons -->
        <b-card>
          <!-- Button: Print -->
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" block @click="addSalesOrder()">
            <b-spinner small v-if="loading"> </b-spinner>
            Save
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import { ref, onUnmounted } from "@vue/composition-api";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { fnSortingDropdown } from "@/libs/customFn";

import { numericValidation } from "@/libs/customFn";
import { CurrencySymbols } from "@/libs/defaultList";
import { mapActions, mapGetters } from "vuex";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Add from "@/views/purchaseorder/Add.vue";
import "@/libs/customValidation";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    CompanyName,
    Address,
    ValidationProvider,
    ValidationObserver,
    fnSortingDropdown,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      id: this.$route.params.id,
      MaindiscountType: 0,
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      discountPlaceholder: "Input discount rate",
      MainDiscount: 0,
      issueDateError: null,
      dueDateError: null,
      checkInv: false,
      optionsCustomer: [],
      whenSelected: [],
      optionsProduct: [],
      optionsSalesPerson: [],
      salesPersonId: "",
      leadClientId: "",
      loadingButton: false,
      orderType: null,
      dueDate: "",
      index: 0,
      warehouseId: "",
      issuedDate: Date.now(),
      note: "",
      userTenant: localStorage.getItem("userTenant"),
      maxDiscountValue: 100,
      currencyOptions: [],
      selectedCurrency: "MUR",
      currencyList: CurrencySymbols,
      exchangeRate: 1,
      tax: 0,
      soId: "",
      optionsWarehouse: [],
      ///order type
      discountTypeOptions: [
        { value: 0, text: "Percentage" },
        { value: 1, text: "Value" },
      ],
      optionsOrderType: [
        // { value: null, text: "Please select an option", disabled: true },
        // { value: 0, text: "Fixed Order" },
        { value: 1, text: "Variable Order" },
        { value: 2, text: "OneOff Order" },
      ],
      config: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      configDue: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      // add product modal
      prodName: "",
      prodQty: null,
      prodInHouse: false,
      newProd: false,
      loadingButton: false,
    };
  },
  mixins: [heightTransition],
  computed: {
    selectedCurrencySign() {
      return this.currencyList[this.selectedCurrency] || "Rs";
    },
    discountTotal() {
      let mainDiscount = Number(this.MainDiscount);

      if (this.MaindiscountType === 0) {
        if (mainDiscount == 0) return 0;

        return (mainDiscount / 100) * this.totalCost;
      } else {
        return mainDiscount;
      }
    },
    subTotal() {
      return this.totalCost - this.discountTotal;
    },
    VATtotal() {
      return this.vat?  this.salesTax : 0;
    },
    finalTotal() {
      let total = this.vat ? this.subTotal + this.VATtotal : this.subTotal;
      return total.toFixed(2);
    },
    mainDiscountRate() {
      let mainDiscount = Number(this.MainDiscount);
      return mainDiscount / 100;
    },
    ...mapGetters("salesOrderModule", {
      loading: "loading",
      NewSalesOrder: "NewSalesOrder",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      custId: "custId",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    optionsOrderTypeDLL() {
      const sortedOptions = fnSortingDropdown(
        this.optionsOrderType.filter((option) => option.value !== null)
      );
      return sortedOptions;
    },
    totalCost() {
      let total = 0;
      this.invoiceData.items.forEach((item) => {
        total += item.cost * item.qty;
      });
      if (isNaN(parseFloat(total.toFixed(2)))) {
        return 0;
      }
      return parseFloat(total.toFixed(2));
    },

    salesTax() {
      let total = 0;

      this.invoiceData.items.forEach((item) => {
        let discountAmount = item.cost * this.mainDiscountRate;
        let discountedPrice = item.cost - discountAmount;
        let prodsalesTax = discountedPrice * (parseFloat(item.tax || 0) / 100);

        total += prodsalesTax * item.qty;
      });

      let totalsalesTax = parseFloat(total.toFixed(2));

      if (isNaN(totalsalesTax)) {
        return 0;
      }
      return totalsalesTax;
    },
    convertPriceRate(currentPrice) {
      return this.selectedCurrency != "MUR"
        ? currentPrice / this.exchangeRate
        : currentPrice;
    },
  },

  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  watch: {
    // Watch for changes in issuedDate
    issuedDate(newVal) {
      this.validateDates();
    },
    // Watch for changes in dueDate
    dueDate(newVal) {
      this.validateDates();
    },
  },

  methods: {
    allowOnlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;

      if (
        (charCode < 48 || charCode > 57) &&  
        charCode !== 46 &&                   
        charCode !== 8                       
      ) {
        event.preventDefault();
          }
      
      if (charCode === 46 && event.target.value.includes('.')) {
        event.preventDefault();
      }
    },
    allowOnlyNumbersProd(event) {
  const charCode = event.which ? event.which : event.keyCode;

  if (
    charCode < 48 || charCode > 57 // Allow only numbers (0-9)
  ) {
    event.preventDefault();
  }
},

    sanitizeInput(field) {
      if(this.invoiceData.items[field]){
        let sanitizedValue = this.invoiceData.items[field].toString().replace(/[^0-9.]/g, '');
      
        const parts = sanitizedValue.split('.');
        if (parts.length > 2) {
          sanitizedValue = parts[0] + '.' + parts[1]; 
        }
      
        this.invoiceData.items[field] = sanitizedValue ? parseFloat(sanitizedValue) : 0;
      }
    },

    validateDates() {
      this.issueDateError = null;
      this.dueDateError = null;

      // Validate issueDate
      if (this.issuedDate && this.dueDate && this.issuedDate > this.dueDate) {
        this.issueDateError = "Issue Date cannot be later than Due Date";
      }

      // Validate dueDate
      if (this.issuedDate && this.dueDate && this.dueDate < this.issuedDate) {
        this.dueDateError = "Due Date cannot be earlier than Issue Date";
      }
    },

    updateCurrency() {
      // Method to update currency and convert item prices
      this.convertPrices();
    },
    formatDiscount() {
      if (this.MainDiscount) {
        this.MainDiscount = parseFloat(this.MainDiscount).toFixed(2);
      }
    },
    convertPrices() {
      // Method to convert item prices based on the selected currency and conversion rate
      this.invoiceData.items.forEach((item) => {
        item.cost = item.purchase * this.conversionRate;
        // Optionally update VAT if needed
        // item.tax = ...;
      });
    },
    updateItemCost(index) {
      const item = this.invoiceData.items[index];
      const purchase = parseFloat(item.purchase);
      const profitPercent = item.profit ? parseFloat(item.profit) : 0;
      const taxPercent = item.tax ? parseFloat(item.tax) : 0;

      // Calculate cost
      const costBeforeProfit = purchase * (1 + taxPercent / 100);
      const profitValue = costBeforeProfit * (profitPercent / 100);
      const totalCost = costBeforeProfit + profitValue;

      this.invoiceData.items[index].cost = parseFloat(totalCost);
      // Update item cost
      //this.$set(this.invoiceData.items[index], "cost", parseFloat(totalCost));
    },
    ensureNotNull(index) {
      if (
        this.invoiceData.items[index].discount == null ||
        this.invoiceData.items[index].discount === ""
      ) {
        this.invoiceData.items[index].discount = 0;
      }
    },
    ensureMainDiscountNotNull() {
      if (this.mainDiscount == null || this.mainDiscount === "") {
        this.mainDiscount = 0;
      }

      this.formatDiscount();
    },
    itemCost(cost, qty, discountType, discount) {
      cost = Number(cost);
      qty = Number(qty);
      discount = Number(discount);

      if (isNaN(cost) || isNaN(qty) || isNaN(discount)) {
        return "0.00";
      }

      let result = cost * qty;

      if (discountType == 0) {
        let discountAmount = result * (discount / 100);

        // Check if discountAmount is greater than the cost of all items
        if (discountAmount > result) {
          // need to set error here instead of just console.warn

          console.warn(
            "Discount cannot exceed total item cost. Discount was set to equal total item cost."
          );
          discountAmount = result;
        }
        result = result - discountAmount;
      } else if (discountType == 1) {
        // Check if flat discount is greater than the cost of all items

        if (discount > result) {
          discount = result;
        }
        result = result - discount;
      }
      return result.toFixed(2);
    },

    validateDiscount(index) {
      console.log(
        "f",
        index,
        this.invoiceData.items[index].discountType,
        this.invoiceData.items[index].discount
      );
      if (
        this.invoiceData.items[index].discountType === 0 &&
        this.invoiceData.items[index].discount > 100
      ) {
        this.$set(this.invoiceData.items[index], "discount", 100);
      } else if (
        this.invoiceData.items[index].discountType === 1 &&
        this.invoiceData.items[index].discount >
        this.invoiceData.items[index].cost * this.invoiceData.items[index].qty
      ) {
        this.$swal({
          title: "Error!",
          html: " Discount cannot exceed total item cost. Discount was set to equal total item cost.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        this.$set(
          this.invoiceData.items[index],
          "discount",
          this.invoiceData.items[index].cost * this.invoiceData.items[index].qty
        );
      }
    },
    ...mapActions("customerModule", [
      "getCustomersListAction",
      "getCustomersByIDAction",
    ]),
    ...mapActions("productModule", [
      "getProductListAction",
      "addProductAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("salesOrderModule", ["addSalesOrdersAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    // add product modal start

    async resetProductModal() {
      this.prodName = "";
      this.prodQty = null;
      this.prodInHouse = false;
      this.newProd = false;
      this.$refs.addProductModal.hide();
    },
    async addProduct() {
      let isValid = await this.$refs.addProduct.validate();

      if (isValid) {
        let payload = {
          name: this.prodName,
          initialQuantity: this.prodQty,
          inHouseManufactured: this.prodInHouse,
        };

        try {
          await this.addProductAction({ product: payload });

          await this.$swal({
            title: "Products!",
            text: "You have successfully added the product!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.newProd = true;

          this.$refs.addProductModal.hide();
          await this.loadProductList();
          await this.resetProductModal();
        } catch (ex) {
          await this.$swal({
            title: "Error!",
            html: ex.response?.data?.message || "Failed!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          await this.resetProductModal();
        }
      }
    },
    // add product modal end
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
    async addSalesOrder() {
      this.loadingButton = true;
      let isValid = await this.$refs.proforma.validate();
      this.$refs.proforma.validate().then((isValid) => {
        if (!isValid) {
          // Find the first invalid field
          const firstErrorField = this.$el.querySelector(".text-danger");
          if (firstErrorField) {
            // Scroll to the first invalid field
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
            // Set focus on the first invalid field
            firstErrorField.focus();
          }
        }
      });
      if (isValid) {
        if (this.invoiceData.items.length === 0) {
          this.$swal(
            "Error",
            "No items added! Please add items before creating a quotation.",
            "error"
          );
          return;
        } else {
          //loader
          let loader = this.$swal({
            title: "Processing...",
            text: "Please wait while Proforma is being added",
            onOpen: () => {
              this.$swal.showLoading();
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
            buttonsStyling: false,
            showConfirmButton: false,
          });

          let payload = {
            leadClientId: this.id,
            salesPersonId: this.salesPersonId,
            issuedDate: new Date(this.issuedDate),
            dueDate: this.dueDate,
            note: this.note,
            status: 0,
            orderType: this.orderType,
            isActive: true,
            warehouseId: this.warehouseId,
            discount: this.discountTotal,
            discountType:
              this.MaindiscountType !== null
                ? String(this.MaindiscountType)
                : "0",
            paymentMethod: "string",
            subTotal: this.subTotal,
            tax: this.salesTax,
            total: this.finalTotal,
            currency: this.selectedCurrency,
            rate: this.selectedCurrency == "MUR" ? 0 : this.exchangeRate,
            orderItems: this.invoiceData.items.map((event) => {
              let discountValue;
              if (event.discountType === 0) {
                discountValue = event.qty * event.cost * (event.discount / 100);
              } else if (event.discountType === 1) {
                discountValue = event.discount;
              } else {
                discountValue = 0;
              }
              return {
                itemId: event.value,
                description: event.description ? event.description : "",
                cost: event.cost,
                qty: event.qty,
                discountType: String(event.discountType),
                discount: discountValue,
                price: event.purchase,
                isActive: true,
                tax: event.tax ?? 0
              };
            }),
          };
          this.addSalesOrdersAction(payload)
            .then(() => {
              this.loadingButton = false;
              loader.close();
              this.soId = this.NewSalesOrder.id;
              this.success();
            })
            .catch((error) => {
              this.loadingButton = false;
              loader.close();
              this.error(error.response.data);
            });
        }
      }
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    // updateInvoiceDataOnRateChange() {
    //   if (this.invoiceData.items.length > 0) {
    //     this.invoiceData.items.map((item, index) => {
    //       let productDetail = this.ProductList.filter(
    //         (x) => x.id == item.value
    //       )[0];
    //       let costValue =
    //         this.selectedCurrency != "MUR"
    //           ? (productDetail.salePrice / this.exchangeRate).toFixed(2)
    //           : productDetail.salePrice;
    //       this.$set(
    //         this.invoiceData.items[index],
    //         "cost",
    //         parseFloat(costValue)
    //       );
    //       let purchasePrice =
    //         this.selectedCurrency != "MUR"
    //           ? (productDetail.purchasePrice / this.exchangeRate).toFixed(2)
    //           : productDetail.purchasePrice;
    //       this.$set(
    //         this.invoiceData.items[index],
    //         "purchase",
    //         parseFloat(purchasePrice)
    //       );
    //     });
    //   }
    // },

    updateInvoiceDataOnRateChange() {
      if (this.invoiceData.items.length > 0) {
        this.invoiceData.items.map((item, index) => {
          var cost = this.invoiceData.items[index].cost != 0 ? this.invoiceData.items[index].cost : this.invoiceData.items[index].inicost;


          let costValue =
            this.selectedCurrency != "MUR"
              ? (cost / this.exchangeRate).toFixed(2)
              : cost;
          this.$set(
            this.invoiceData.items[index],
            "cost",
            parseFloat(costValue)
          );
        });
      }
      this.prevrate = this.exchangeRate;
    },

    // Method to show SweetAlert notifications
    showMessage(icon, title, msg, reRoute) {
      this.$swal({
        title: title,
        text: msg,
        icon: icon,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value && reRoute) {
          this.$router.push({ name: reRoute });
        }
      });
    },

    // Success handler for successful transactions
    success() {
      this.$swal({
        title: "Proforma Added!",
        text: "You have successfully added the Proforma!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(this.$router.push("/proforma/view/" + this.soId));
    },

    // Error handler for failed transactions
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? "Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    // Helper to format error messages from API response
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (let prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    async customerSelected(id) {
      this.whenSelected = null;
      this.getCustomersByIDAction(id).then((response) => {
        this.whenSelected = this.custId;
      });
    },
    async loadProductList() {
      await this.getProductListAction(true).then(() => {
        this.ProductList.map((v, i) => {
          if (v.type !== 4) {
            this.optionsProduct.push({
              qty: 1,
              value: v.id,
              itemTitle: `${v.name}`,
              categoryName: v.categoryName || "-", // Default to "No Category" if null
            subCategoryName: v.subCategoryName || "-", // Default to "No Subcategory" if null
              cost: v.salePrice,
              tax: v.saleTaxPercentage,
              purchase: v.purchasePrice,
              profit: v.markUpPercentage,
              description: v.description,
            });
          }
        });
      });
      this.optionsProduct = this.optionsProduct.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
      this.optionsProduct = fnSortingDropdown(
        this.optionsProduct,
        "asc",
        "itemTitle"
      );
    },
  },

  beforeMount() {
    this.getWarehouseListAction();
    this.getCustomersListAction();
    this.getSalesPersonListAction();
    this.getProductListAction(true);
  },
  async mounted() {
    this.initTrHeight();
    this.currencyOptions = Object.keys(this.currencyList).map((x) => {
      return { text: x, value: x };
    });
    this.currencyOptions = fnSortingDropdown(
      this.currencyOptions,
      "asc",
      "text"
    );
    this.whenSelected = null;
    this.customerSelected(this.$route.params.id);

    if (this.warehouse == undefined || this.warehouse.length == 0)
      await this.getWarehouseListAction();
    if (this.CustomerList == undefined || this.CustomerList.length == 0)
      await this.getCustomersListAction();
    if (this.SalesPersonList == undefined || this.SalesPersonList.length == 0)
      await this.getSalesPersonListAction();
    if (this.ProductList == undefined || this.ProductList.length == 0)
      await this.getProductListAction(true);
    this.warehouse.map((v, i) =>
      this.optionsWarehouse.push({
        value: v.id,
        text: `${v.name}`,
      })
    );

    this.optionsWarehouse = fnSortingDropdown(this.optionsWarehouse);
    //await this.getTenantIdAction(this.userTenant);
    this.CustomerList.map((v, i) =>
      this.optionsCustomer.push({
        value: v.id,
        text: `${v.otherName} ${v.surname ?? ''}`,
      })
    );

    this.optionsCustomer = fnSortingDropdown(this.optionsCustomer);

    this.SalesPersonList.map((v, i) =>
      this.optionsSalesPerson.push({
        value: v.id,
        text: `${v.firstName}` + " " + `${v.lastName}`,
      })
    );

    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
    await this.loadProductList();
  },
  setup() {
    //const { root } = context;

    const itemFormBlankItem = {
      item: null,
      value: null,
      cost: 0,
      purchase: 0,
      qty: 1,
      tax: 0,
      profit: 0,
      description: "",
      discountType: 0,
      discount: 0,
    };

    const invoiceData = ref({
      id: 5037,
      client: null,
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],
      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val, exchangeRate, selectedCurrency) => {
      const {
        cost,
        qty,
        description,
        purchase,
        tax,
        profit,
        value,
        discount,
        discountType,
      } = val;

      invoiceData.value.items[index].cost =
        selectedCurrency != "MUR"
          ? (val.cost / exchangeRate).toFixed(2)
          : val.cost;

      console.log(val);

      // Update the item data
      invoiceData.value.items[index].cost = cost ?? 0;
      invoiceData.value.items[index].qty = qty;
      invoiceData.value.items[index].value = value;

      if (discount) {
        invoiceData.value.items[index].discount = discount ?? 0;
        invoiceData.value.items[index].discountType = discountType ?? 0;
      }

      invoiceData.value.items[index].tax = tax;
      invoiceData.value.items[index].profit = profit;
      invoiceData.value.items[index].purchase =
        selectedCurrency != "MUR"
          ? (val.purchase / exchangeRate).toFixed(2)
          : purchase;
      invoiceData.value.items[index].description = description;

      // Validate discount and set error flag
      if (discountType === 0 && discount > 100) {
        invoiceData.value.items[index].discount = 100;
      } else if (discountType === 1 && discount > purchase * qty) {
        invoiceData.value.items[index].discount = purchase * qty;
      }
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.invoice-total-wrapper {
  width: 100% !important;
  max-width: 30rem !important;
}

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>
<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
